import { Route } from '@angular/router';

import {
  Colors,
  Typography,
  Containers,
  Layout,
  Icons,
  Buttons,
  ListItems,
  AppElements,
  Badges,
  Dialogs,
  Menus,
  TokenOverview,
  Inputs,
  Dividers,
  Tooltips,
  Selects,
  Notifications,
  Avatars,
  Emojis,
  Chips,
  Tabs,
  IconCallouts,
  Loaders,
  Tables,
  Animations,
  PhoneNumbers,
  DatePickers,
  TimePickers,
  DateTimePickers,
} from './views';

export const appRoutes: Route[] = [
  {
    path: 'tokens',
    component: TokenOverview,
  },
  {
    path: 'colors',
    component: Colors,
  },
  {
    path: 'typography',
    component: Typography,
  },
  {
    path: 'containers',
    component: Containers,
  },
  {
    path: 'layout',
    component: Layout,
  },
  {
    path: 'icons',
    component: Icons,
  },
  {
    path: 'buttons',
    component: Buttons,
  },
  {
    path: 'list-items',
    component: ListItems,
  },
  {
    path: 'app-elements',
    component: AppElements,
  },
  {
    path: 'badges',
    component: Badges,
  },
  {
    path: 'dialogs',
    component: Dialogs,
  },
  {
    path: 'menus',
    component: Menus,
  },
  {
    path: 'inputs',
    component: Inputs,
  },
  {
    path: 'dividers',
    component: Dividers,
  },
  {
    path: 'tooltips',
    component: Tooltips,
  },
  {
    path: 'selects',
    component: Selects,
  },
  {
    path: 'notifications',
    component: Notifications,
  },
  {
    path: 'avatars',
    component: Avatars,
  },
  {
    path: 'emojis',
    component: Emojis,
  },
  {
    path: 'chips',
    component: Chips,
  },
  {
    path: 'tabs',
    component: Tabs,
  },
  {
    path: 'icon-callout',
    component: IconCallouts,
  },
  {
    path: 'loaders',
    component: Loaders,
  },
  {
    path: 'tables',
    component: Tables,
  },
  {
    path: 'animations',
    component: Animations,
  },
  {
    path: 'phone-numbers',
    component: PhoneNumbers,
  },
  {
    path: 'date-pickers',
    component: DatePickers,
  },
  {
    path: 'time-pickers',
    component: TimePickers,
  },
  {
    path: 'date-time-pickers',
    component: DateTimePickers,
  },
  {
    path: '**',
    redirectTo: 'colors',
    pathMatch: 'full',
  },
];
